import {inject, ref} from 'vue';

export default {
    install: (app, options) => {
        const profileUser = ref(null);
        const profileUserChannel = ref(null);
        const availablePaths = ref([]);
        const availableEditors = ref([]);

        const loadProfileUser = () => {
            window.lazy_axios.get('/profile')
                .then((response) => {
                    if (response.data.profile) {
                        profileUser.value = response.data.profile;
                        // document.dispatchEvent(new CustomEvent('loaded.profile'));

                        if (window.Echo) {
                            profileUserChannel.value = window.Echo.private(`profile.user.${response.data.profile.id}`);
                        }
                    }
                    if (response.data.available_paths) {
                        availablePaths.value = response.data.available_paths;
                    }
                    if (response.data.available_actions) {
                        availableEditors.value = response.data.available_actions;
                    }
                });
        };

        const clearProfileUserAll = () => {
            profileUser.value = null;
            availablePaths.value = [];
            availableEditors.value = [];
        };

        const userCanSeePage = (path) => {
            if (availablePaths.value && profileUser.value) {
                return availablePaths.value.includes(path);
            }

            return false;
        };

        const userCanAction = (editor) => {
            if (availableEditors.value && profileUser.value) {
                return availableEditors.value.includes(editor);
            }

            return false;
        };

        app.provide('profileUser', profileUser);
        app.provide('profileUserChannel', profileUserChannel);
        app.provide('loadProfileUser', loadProfileUser);

        app.provide('profileUserProvider', {
            profileUser,
            profileUserChannel,
            availablePaths,
            availableEditors,
            loadProfileUser,
            clearProfileUserAll,
            userCanSeePage,
            userCanAction,
        });
    },
}
